/** @enum {string} */
export const SalaryPeriod = Object.freeze({
  HOURLY: 'hourly',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  ANNUAL: 'annual',
});

/** Multipliers to normalize any period to annual equivalent */
export const ANNUAL_MULTIPLIER = Object.freeze({
  [SalaryPeriod.HOURLY]: 2080,
  [SalaryPeriod.WEEKLY]: 52,
  [SalaryPeriod.MONTHLY]: 12,
  [SalaryPeriod.ANNUAL]: 1,
});
